import { render, staticRenderFns } from "./SpadL_List.vue?vue&type=template&id=3916afcf"
import script from "./SpadL_List.vue?vue&type=script&lang=js"
export * from "./SpadL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports